import React from "react";

import AccountLayout from "../../components/AccountLayout";
import AccountRoute from "../../components/AccountRoute";
import AppLayout from "../../components/AppLayout";
import NotificationPreferences from "../../page-components/NotificationPreferences";

function NotificationPreferencesPage(props) {
  return (
    <AppLayout
      withFooter={false}
      pageTitle="Notification Preferences"
      shouldIndex={false}
    >
      <AccountLayout
        {...props}
        render={(props) => (
          <AccountRoute
            path="/account/notification-preferences"
            Component={NotificationPreferences}
            {...props}
          />
        )}
      />
    </AppLayout>
  );
}

export default NotificationPreferencesPage;
